<template>
  <div>
    <RevDrawer
      name="modal.financial_report.filters.mobile"
      :title="i18n(translations.filters)"
    >
      <template #body>
        <form>
          <div class="flex flex-col space-y-4">
            <RevInputSelect
              id="time-period"
              v-model="filtersValues.timeframe as Value"
              :label="i18n(translations.timeframe)"
              :options="timePeriodsOptions"
            />
            <RevInputSelect
              id="currency"
              v-model="filtersValues.currency as Value"
              :label="i18n(translations.currency)"
              :options="currenciesOptions"
            />
          </div>
        </form>
      </template>
      <template #footer="{ close }">
        <div class="flex">
          <RevButton
            class="mr-1"
            full-width="always"
            type="submit"
            variant="primary"
            @click="handleSubmit(close)"
          >
            {{ i18n(translations.applyFilters) }}
          </RevButton>

          <RevButton
            full-width="always"
            variant="secondary"
            @click="handleReset(close)"
          >
            {{ i18n(translations.resetFilters) }}
          </RevButton>
        </div>
      </template>
      <template #trigger="{ open }">
        <RevStickyBar class="md:hidden">
          <div class="flex items-center justify-center">
            <RevButton
              :icon="IconEqualizer"
              size="small"
              variant="secondary"
              @click="open"
            >
              {{ i18n(translations.filter) }}
            </RevButton>
          </div>
        </RevStickyBar>
      </template>
    </RevDrawer>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import {
  type Option,
  RevInputSelect,
  type Value,
} from '@ds/components/InputSelect'
import { RevStickyBar } from '@ds/components/StickyBar'
import { IconEqualizer } from '@ds/icons/IconEqualizer'

import translations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

const props = defineProps<{
  currenciesOptions: Option[]
  timePeriodsOptions: Option[]
  resetFilters: () => void
  submitFilters: () => void
}>()

const i18n = useI18n()

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

function handleSubmit(closeModal: () => void) {
  props.submitFilters()
  closeModal()
}

function handleReset(closeModal: () => void) {
  props.resetFilters()
  closeModal()
}
</script>
